import {
  IsBoolean,
  IsIn,
  IsNotEmpty,
  IsNumber,
  IsOptional,
  IsString,
} from "class-validator";
import { BankAccountType, BA_TYPES } from "./enums/bank-account-types";

export class BankAccountLegalEntityInfoDto {
  id: number;
  name: string;
  inn: string;
}

export class BankAccountBankDetailsInfoDto {
  id: number;
  bankName: string;
  bik: string;
  accountNumber: string;
}

export class BankAccountDto {
  id: number;
  isActive: boolean;
  type: BankAccountType;
  title: string;
  legalEntityId: number;
  bankDetailsId: number;
  /** Разрешено ли использовать этот расчётный счёт для исходящих (клиентских) счетов и договоров */
  allowOutgoingInvoices: boolean;

  // наше юр. лицо и реквизиты — для отображения в справочнике и поиска дублей расчётных счетов
  legalEntity?: BankAccountLegalEntityInfoDto | null;
  bankDetails?: BankAccountBankDetailsInfoDto | null;
}

export class BankAccountInfoDto {
  id?: number;
  type: BankAccountType;
  title: string;
  legalEntityId: number;
  bankDetailsId: number;
}

export class CreateBankAccountDto {
  @IsString()
  @IsNotEmpty()
  title: string;

  // @Type(() => Number)
  @IsIn([...Object.keys(BA_TYPES).map(Number)])
  @IsNumber()
  type: BankAccountType;

  @IsOptional()
  @IsNumber()
  legalEntityId?: number;

  @IsOptional()
  @IsNumber()
  bankDetailsId?: number;

  @IsBoolean()
  isActive: boolean;

  @IsOptional()
  @IsBoolean()
  allowOutgoingInvoices?: boolean;
}

export class UpdateBankAccountDto extends CreateBankAccountDto {
  @IsNumber()
  id: number;
}
